import { MutationTree } from 'vuex';
import { State } from './state';
import { LongList, SetLongListStakeholderObject, Umfrage } from '@/models/UmfrageModels';

export enum MutationTypes {
  SetUmfragen = 'SETUMFRAGEN',
  AddUmfrage = 'ADDUMFRAGE',
  UpdateUmfrage = 'UPDATEUMFRAGE',
  DeleteUmfrage = 'DELETEUMFRAGE',

  SetLonglist = 'SETLONGLIST',
  UpdateLonglist = 'UPDATELONGLIST',
  AddOrUpdateLonglistRange = 'ADDORUPDATELONGLISTRANGE',
  DeleteLonglist = 'DELETELONGLIST',

  SetLonglistStakeholder = 'SETLONGLISTSTAKEHOLDER',
  DeleteLonglistStakeholder = 'DELETELONGLISTSTAKEHOLDER',
}

export type Mutations = {
  [MutationTypes.SetUmfragen](state: State, umfrageliste: Array<Umfrage>): void;
  [MutationTypes.AddUmfrage](state: State, umfrage: Umfrage): void;
  [MutationTypes.UpdateUmfrage](state: State, umfrage: Umfrage): void;
  [MutationTypes.DeleteUmfrage](state: State, umfrageguid: string): void;

  [MutationTypes.SetLonglist](state: State, longlist: Array<LongList>): void;
  [MutationTypes.UpdateLonglist](state: State, longlist: LongList): void;
  [MutationTypes.AddOrUpdateLonglistRange](state: State, data: Array<LongList>): void;
  [MutationTypes.DeleteLonglist](state: State, longlist: LongList): void;

  [MutationTypes.SetLonglistStakeholder](state: State, data: SetLongListStakeholderObject): void;
};

export const mutations: MutationTree<State> & Mutations = {
  //#region Umfragen
  [MutationTypes.SetUmfragen](state: State, umfrageliste: Array<Umfrage>) {
    state.umfragen = umfrageliste;
    sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
  },

  [MutationTypes.AddUmfrage](state: State, umfrage: Umfrage) {
    state.umfragen.push(umfrage);
    sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
  },

  [MutationTypes.UpdateUmfrage](state: State, umfrage: Umfrage) {
    const oldumfrage = state.umfragen.find((a) => a.guid === umfrage.guid);
    if (oldumfrage != null) {
      const index = state.umfragen.indexOf(oldumfrage);
      umfrage.longlist = state.umfragen[index].longlist;
      state.umfragen.splice(index, 1, umfrage);
    }

    sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
  },

  [MutationTypes.DeleteUmfrage](state: State, umfrageguid: string) {
    const oldumfrage = state.umfragen.find((a) => a.guid === umfrageguid);
    if (oldumfrage != null) {
      const index = state.umfragen.indexOf(oldumfrage);
      state.umfragen.splice(index, 1);
    }

    sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
  },
  //#endregion

  //#region Longlist
  [MutationTypes.SetLonglist](state: State, longlist: Array<LongList>) {
    if (longlist.length > 0) {
      const umfrage = state.umfragen.find((a) => a.guid === longlist[0].umfrageGuid);
      if (umfrage != null) {
        umfrage.longlist = longlist;
      }

      sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
    }
  },

  [MutationTypes.UpdateLonglist](state: State, longlist: LongList) {
    const umfrage = state.umfragen.find((a) => a.guid === longlist.umfrageGuid);
    if (umfrage != null) {
      const index = umfrage.longlist.findIndex((a) => a.id === longlist.id);
      if (index != -1) {
        umfrage.longlist.splice(index, 1, longlist);
      }
    }

    sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
  },

  [MutationTypes.AddOrUpdateLonglistRange](state: State, data: Array<LongList>) {
    if (data.length > 0) {
      const umfrage = state.umfragen.find((a) => a.guid === data[0].umfrageGuid);
      if (umfrage != null) {
        for (let longlist of data) {
          const index = umfrage.longlist.findIndex((a) => a.id === longlist.id);
          if (index != -1) {
            umfrage.longlist.splice(index, 1, longlist);
          } else {
            umfrage.longlist.push(longlist);
          }
        }
      }

      sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
    }
  },

  [MutationTypes.DeleteLonglist](state: State, longlist: LongList) {
    const umfrage = state.umfragen.find((a) => a.guid === longlist.umfrageGuid);
    if (umfrage != null) {
      const index = umfrage.longlist.findIndex((a) => a.id === longlist.id);
      if (index != -1) {
        umfrage.longlist.splice(index, 1);
      }
    }

    sessionStorage.setItem('umfragen', JSON.stringify(state.umfragen));
  },
  //#endregion

  [MutationTypes.SetLonglistStakeholder](state: State, data: SetLongListStakeholderObject) {
    const umfrage = state.umfragen.find((a) => a.guid === data.umfrageGuid);
    if (umfrage != null) {
      for (let longlist of umfrage.longlist) {
        const stakeholder = data.stakeholder.filter((a) => a.longlistid === longlist.id);
        if (stakeholder.length > 0) {
          longlist.stakeholder = stakeholder;
        }
      }
    }
  },
};
